import Nav from "components/Nav";
import SideNav from "components/SideNav";

export default function MainLayout({ children, color }) {
  return (
    <div>
      <Nav color={color} />
      {children}
    </div>
  );
}
